import { FilterDefaults } from "../../models/filter-defaults.model";
import { FilterDisplay } from "../../models/filter-display.enum";
import { FilterOption } from "../../models/filter-option.model";
import { FilterType } from "../../models/filter-type.enum";
import { FilterAdapter } from "../filter-adapter.interface";

export class PeriodoAdapter implements FilterAdapter <any>{
  readonly type = FilterType.TREE;

  readonly defaults: FilterDefaults = {
    multiple: false,
    searchable: false,
    removableChips: false,
    visible: true,
    disabled: false,
  };

  adapt(periodos: any[]): FilterOption[] {
    return periodos.filter( periodo => periodo.visible)
    .map(periodo => this.mapPeriodo(periodo));
  }

  adaptBusqueda(busqueda: boolean): void{
    this.defaults.searchable = busqueda;  
  }
  
  adaptConsolidado(textoConsolidado: string, consolidado: boolean): void {}

  private mapPeriodo(periodo: any): FilterOption{
    return {
      id: periodo.anio,
      label: periodo.anio.toString(),
      value: periodo,
      visible: periodo.visible,
      children: periodo.series
      .filter(mes => mes.visible)
      .map(mes => ({
          id: `${mes.mes}.${mes.anio}`,
          label: `${mes.mes}`,
          value: mes,
          selected: mes.check,
          visible: mes.visible
      }))
    };
  }
}